import { Dispatch } from 'redux';

import CustomAppTypes from '../config/customAppTypes';
import { AppState } from '../reducers';
import { errorNames } from '../util/mappings/errorName';
import { customFailed } from '../util/navUtil';
import parseUrlParams from '../util/urlParams';
import { fetchAgriMember, fetchAgriMemberFailed } from './agri';
import { actionTypes, AppActions } from './types';

type Action<T> = import('./types').Action<T>;
type UrlParamTypes = any; // TODO: Add types!

export interface GetUrlParamsAction extends Action<typeof actionTypes.PARAM_STATE_UPDATE> {
    type: typeof actionTypes.PARAM_STATE_UPDATE;
    payload: UrlParamTypes;
}

export type UrlParamsActions = GetUrlParamsAction;

export const getUrlParams = (params: UrlParamTypes): GetUrlParamsAction => ({
    type: actionTypes.PARAM_STATE_UPDATE,
    payload: params,
});

export const fetchParams = (dispatch: Dispatch<AppActions>, getState: () => AppState): void => {
    /* Get URL Params (before getting the paramType) IE11 safe version */
    const urlParams = parseUrlParams();
    /* We need to run params even though it is empty, to set card type from default */
    dispatch(getUrlParams(urlParams));

    // Agricard specific
    const { appType } = getState().context;
    const { hasCards } = getState().cards;
    const { agricard } = urlParams;
    if (appType === 'agricard') {
        if (CustomAppTypes.isAgri(getState().context) && agricard && agricard.length > 0) {
            fetchAgriMember(dispatch, getState);
        } else if (!hasCards) {
            fetchAgriMemberFailed(customFailed(errorNames.agriTokenValidFailed));
        }
    }
};
